import React from 'react';
import { IParentComponent } from '../interfaces/IParentComponent';
import classNames from 'classnames';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

export const SubHeaderTextTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-lg font-semibold leading-6', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'sub-header-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'header-tw')}
      {...rest}
    >
      {children}
    </div>
  );
};
